<template>
  <div class="container m-top-40 separate-list-container">
    <confirmation-popup
        title="Warning"
        message="Are you sure you want to delete this property??"
        :id="confirmationDialogId" @on-confirm="onCustomerPropertyDeleteConfirm"></confirmation-popup>
    <div class="row m-top-20">
      <div class="col-md-12">
        <div class="col-md-12">
          <div class="float-left">
            <div class="float-left">
              <a href="#" @click="goToCustomerViewPage()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#03A9F4"/>
              </svg>
              </a>
            </div>
            <div class="float-left m-left-20">
              <span class="separate-properties-list-title">Customer properties</span>
            </div>
          </div>
          <div class="float-right">
            <customer-property-creation-popup :property='property' :customer-id="customerId"
                                              :country-code="countryCode" :date-format="dateFormat"
                                              :id="`create_popup_${property.property_id}`"></customer-property-creation-popup>
            <span class="float-right  m-left-20 new-text">New</span>
            <a class="float-right" data-toggle="modal" :data-target="`#create_popup_${property.property_id}`">
              <svg width="20" height="20" style="fill: #03A9F4; display: inline;"
                   viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                    fill="#03A9F4"/>
              </svg>
            </a>


          </div>


        </div>
      </div>
    </div>
    <div class="m-top-30">
      <div v-if="ascending" class="col-md-6" @click="ascending = !ascending">
        <span class="m-right-6">Sort Z-A</span>
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12.3164 1.70504L10.9064 0.295044L6.31641 4.87504L1.72641 0.295043L0.316406 1.70504L6.31641 7.70504L12.3164 1.70504Z"
              fill="#03A9F4"/>
        </svg>
      </div>
      <div v-else class="col-md-6" @click="ascending = !ascending">
        <span class="m-right-6">Sort A-Z</span>
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12.3164 1.70504L10.9064 0.295044L6.31641 4.87504L1.72641 0.295043L0.316406 1.70504L6.31641 7.70504L12.3164 1.70504Z"
              fill="#03A9F4"/>
        </svg>
      </div>
      <div class="col-md-6 text-align-right">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
              fill="#03A9F4"/>
        </svg>
        <input class="m-left-6" type="text" v-model="searchValue" placeholder="Search" id="search-input"></input>
      </div>
    </div>

    <div class="col-md-12 m-top-25"></div>

    <div class="col-md-12">
      <customer-property-item v-for="(detail,key) of filteredDetails" :key="key" :property="detail"
                              :property-name="property.property_name" :country-code="countryCode"
                              :date-format="dateFormat"
                              :customer-id="customerId"></customer-property-item>

    </div>
  </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {deleteCustomerProperties} from "@/modules/Customer/api"

export default {
  name: "CustomerPropertiesSeparateList",
  props: {
    base64EncodedProperty: '',
    countryCode: {
      required: true
    },
    dateFormat: {
      required: true
    },
    customerId: {
      required: true
    }
  },
  data() {
    return {
      property: JSON.parse(atob(this.base64EncodedProperty)),
      confirmationDialogId: 'customer-property-confirmation',
      toBeDeletedProperty: null,
      customerViewPage:'/customer/view',
      ascending: true,
      searchValue: '',
    }
  },
  methods: {
    getTargetedPropertyByCustomerPropertyId(property) {
       return this.property.details.find(detail => {
        if (detail.customer_property_id == property.customer_property_id)
          return true
      })
    },
    removePropertyVisually(property) {
      this.property.details.splice(this.property.details.indexOf(property), 1)
      this.$forceUpdate()
    },
    initiateListeners() {
      EventBus.$on('onCustomerPropertyDeleted', property => {
        this.toBeDeletedProperty = property
        $(`#${this.confirmationDialogId}`).modal('show')
      })

      EventBus.$on('onCustomerPropertyCreated', property => {
        property.value = property.customer_primary_field_vlaue
        if (this.property.hasOwnProperty('details')) {
          this.property.details.push(property)
        } else {
          this.property.details = []
          this.property.details.push(property)
        }
        this.$forceUpdate()
      })
    },
    onCustomerPropertyDeleteConfirm() {
      EventBus.$emit('onCustomerPropertyConfirmDeleted', this.toBeDeletedProperty) // I am here
      deleteCustomerProperties(this.toBeDeletedProperty)
          .then(response => {
            this.removePropertyVisually(this.toBeDeletedProperty)
          })

    },
    goToCustomerViewPage(){
      window.location.replace(`${this.customerViewPage}/${this.customerId}`)
    },
  },
  computed:{
       filteredDetails(){
         let tempDetails = this.property.details
         if (this.searchValue != '' && this.searchValue) {
           tempDetails = tempDetails.filter((item) => {
             return item.value
                 .toUpperCase()
                 .includes(this.searchValue.toUpperCase())
           })
         }
         tempDetails = tempDetails.sort((a, b) => {
             let fa = a.value.toLowerCase(), fb = b.value.toLowerCase()
             if (fa < fb) {
               return -1
             }
             if (fa > fb) {
               return 1
             }
             return 0
         })

         // Show sorted array in descending or ascending order
         if (!this.ascending) {
           tempDetails.reverse()
         }

         return tempDetails
       }
  },
  mounted() {
    this.initiateListeners();
  }
}
</script>

<style scoped>
.separate-list-container {
  background-color: #FFFFFF;
}
.separate-properties-list-title{
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
}
.new-text{
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
}
</style>